

















































































































import Vue from 'vue';
import { Component, Prop, Watch } from "vue-property-decorator";
import { ReportFilter, ReportParameter, IReportParameter } from "@/entities";

@Component
export default class AdvanceSearchComponent extends Vue {
    @Prop() fields!: Array<ReportFilter>;
    @Prop() selectedParams!: Array<ReportParameter>;

    menu: boolean = false;
    fieldName: string = '';
    operator: Array<any> = [];
    operators: Array<any> = [];
    autofocus: boolean = false;
    autofocusField: boolean =  true;
    selectedField: ReportFilter = null;
    //selectedParams: Array<ReportParameter> = [];
    currentFilter: ReportParameter = null;
    filterKey: number = 0;

    items: Array<any> = []

    /** boolean operators */
    booleanOperators: Array<any> = [
        { key: 'Yes', value: 1 },
        { key: 'No', value: 0 }
    ];

     /** date operators */
    dateOperators: Array<any> = [
        { key: '=', value: '=' },
        { key: '!=', value: '!=' },
        { key: '<', value: '<' },
        { key: '>', value: '>' },
        { key: '>=', value: '>=' },
        { key: '<=', value: '<=' },
        { key: 'Month To Date', value: 'MTD' },
        { key: 'Year To Date', value: 'YTD' },
        { key: 'Quarter To Date', value: 'QTD' },
        { key: 'Today', value: 'TDY' },
        { key: 'Prior Month', value: 'LM' },
        { key: 'This Month', value: 'TM' },
        { key: 'Last 2 Weeks', value: 'L2WK' },
        { key: 'Last Week', value: 'LWK' },
        { key: 'This Week', value: 'TWK' },
        { key: 'Yesterday', value: 'YDY' },
        { key: 'Days Ago', value: 'DA' },
        { key: 'Last Financial Year', value: 'LFY' },
        { key: 'This Financial Year', value: 'TFY' },
        { key: 'Prior Year', value: 'LY' },
        { key: 'This Year', value: 'TY' },
        { key: 'Prior Quarter', value: 'PQ' },
        { key: 'Between', value: 'BTW' }
    ];

    defaultDateOperator: string = '=';

    /** Int operators */
    intOperators: Array<any> =  [
        { key: '=', value: '==' },
        { key: '!=', value: '!=' },
        { key: '<', value: '<' },
        { key: '>', value: '>' },
        { key: '>=', value: '>=' },
        { key: '<=', value: '<=' },
        { key: 'Between', value: 'Between' }
    ];

    /** dropdowns */
    foreignOperators: Array<any> = [
        { key: 'In', value: '==' },
        { key: 'Not In', value: '!=' }
    ];

    defaultForeignOperator: any = '==';

    /** string operators */
    stringOperators: Array<any> = [
        { key: 'Equals', value: 'Equals' },
        { key: 'Not Equals', value: 'NotEquals' },
        { key: 'Contains', value: 'In' },
        { key: 'Not Contains', value: 'NotIn' }
    ];

    defaultStringOperator: any = 'In';

    /*
        * Search input change event.
    */
    _change(fieldName) {
        this.selectedField = this.fields.find(x => x.Field == fieldName);
        let type = this.selectedField.Type;
        this.items = this.selectedField.Items;

        this.currentFilter = this.selectedParams.find(x => x.Field == fieldName);
        if(! this.currentFilter) {
            const { Name, Field, Type, DataType } = this.selectedField;
            var currentParam: ReportParameter = new ReportParameter({ Name, Field, Type, DataType } as IReportParameter);

            if(type == 'TextInput' || type == 'Number' ||  type == 'TextArea') {
                currentParam.Operator = this.defaultStringOperator;
            } else if(type == 'ComboBox') {
                currentParam.Operator = this.defaultForeignOperator;
            } else if(type == 'Date' || type == 'DateWithTime') {
                currentParam.Operator = this.defaultDateOperator;
            } else if(type == 'SwitchInput') {
                currentParam.Operator = this.defaultDateOperator;
            }
            this.selectedParams.push(currentParam);
            this.currentFilter = currentParam;
        }

        if(type == 'TextInput' || type == 'Number' ||  type == 'TextArea') {
            this.operators = this.stringOperators;
        } else if(type == 'ComboBox') {
            this.foreignOperators.map(o => {
                o.key = this.$t(o.key)
            });
            this.operators = this.foreignOperators;
        } else if(type == 'Date' || type == 'DateWithTime') {
            this.operators = this.dateOperators;
        } else if(type == 'SwitchInput') {
            this.operators = this.dateOperators;
        }
    }

    _opChange() {
        this.autofocus = true;
        this.autofocusField = false;

        Vue.nextTick(() => {
            //#.Add the component back in
            this.autofocusField = true;
        });                   
        
    }

    removeFilter(fieldName) {
        const selectedIndex: number = this.selectedParams.findIndex(x => x.Field == fieldName);
        if(selectedIndex >= 0) {
            this.selectedParams.splice(selectedIndex, 1);
            this.filterKey += 1;
            this.fieldName = '';
            this.currentFilter = null;
            this.$emit('filterChanged');
        }        
    }

    removeFilters() {
        this.selectedParams.length = 0
        this.filterKey += 1;
        this.fieldName = '';
        this.currentFilter = null;
        this.$emit('filterChanged');
    }

    addFilter() {
        this.menu = false;
        this.currentFilter = null;
        this.fieldName = '';
        this.$emit('filterChanged');
    }

    displayText(param: ReportParameter) {
        const field = this.fields.find(x => x.Field === param.Field);
        return field.Items.filter(x => param.Values.includes(x.Id)).map(x => x.Name).join(', ');
    }

    getOperator(param: ReportParameter) {
        let type = param.Type;
        if(type == 'TextInput' || type == 'Number' ||  type == 'TextArea') {            
            return this.stringOperators.find(x => x.value == param.Operator).key;
        } else if(type == 'ComboBox') {
            return this.foreignOperators.find(x => x.value == param.Operator).key;
        } else if(type == 'Date' || type == 'DateWithTime') {
            return this.dateOperators.find(x => x.value == param.Operator).key;
        } else if(type == 'SwitchInput') {
            return this.dateOperators.find(x => x.value == param.Operator).key;
        }
    }

}

